import React from "react";
import { Navbar, Nav, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Logo from "../../Assets/Originals/lisa.jpg";
import "./glass.css";

const NavigationBar = ({ onLoginClick = () => {} }) => {
  const navigate = useNavigate();

  return (
    <div>
      <Navbar
        expand="lg"
        className="glass-bar glass-sheen nav-glass"
        style={{
          height: "80px",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          padding: "0 80px",
          zIndex: 1000,
          fontFamily: "'Poppins', sans-serif",

          // Glass Effect
          background:
            "linear-gradient(to bottom, rgba(255,255,255,0.18), rgba(255,255,255,0.08))",
          backdropFilter: "blur(20px) saturate(180%)",
          WebkitBackdropFilter: "blur(20px) saturate(180%)",
          borderBottom: "1px solid rgba(255,255,255,0.18)",
          boxShadow: "0 12px 40px rgba(0,0,0,0.25)",
        }}
      >
        {/* BRAND */}
        <Navbar.Brand
          onClick={() => navigate("/")}
          style={{
            display: "flex",
            alignItems: "center",
            fontWeight: "700",
            fontSize: "2rem",
            color: "rgba(6, 41, 8, 1)",
            letterSpacing: "3px",
            cursor: "pointer",
          }}
        >
          <img
            src={Logo}
            alt="LISA Logo"
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              marginRight: "15px",
            }}
          />
          L.I.S.A.
          <span
            style={{
              fontSize: "1.1rem",
              fontWeight: "400",
              marginLeft: "10px",
            }}
          >
            (Local Irrigation System Assessment)
          </span>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav
            style={{
              marginLeft: "auto",
              display: "flex",
              alignItems: "center",
              gap: "15px",
            }}
          >
            {/* ABOUT BUTTON */}
            <Button
              onClick={() => navigate("/about")}
              style={{
                fontSize: "1rem",
                padding: "10px 20px",
                backgroundColor: "#8B5E3C",
                border: "none",
                borderRadius: "25px",
                minWidth: "100px",
                transition: "all 0.3s ease",
              }}
              onMouseOver={(e) =>
                (e.target.style.backgroundColor = "#A47149")
              }
              onMouseOut={(e) =>
                (e.target.style.backgroundColor = "#8B5E3C")
              }
            >
              About
            </Button>

            {/* LOGIN BUTTON */}
            <Button
              onClick={onLoginClick}
              style={{
                fontSize: "1rem",
                padding: "10px 20px",
                backgroundColor: "rgb(52, 142, 56)",
                border: "none",
                borderRadius: "25px",
                minWidth: "100px",
                transition: "all 0.3s ease",
              }}
              onMouseOver={(e) =>
                (e.target.style.backgroundColor = "rgb(40,120,45)")
              }
              onMouseOut={(e) =>
                (e.target.style.backgroundColor = "rgb(52, 142, 56)")
              }
            >
              Login
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};

export default NavigationBar;
